import axios, {AxiosError} from "axios";
import ApiError, {ApiErrorType} from "../ApiError";
import {authRepository} from "../Repositories/AuthRepository";

const urlBase = window.API_CONFIG.ROOT;

export default class HttpService
{
    public static async get<T>(url: string) : Promise<T>
    {
        url = urlBase + url;
        const response = await axios.get(url, { headers: this.createHeader()})
          .catch((error: AxiosError) =>
          {
              return Promise.reject(this.handleError(error));
          });

        return response.data;
    }

    public static async downloadFile<T>(url: string) : Promise<T>
    {
        url = urlBase + url;
        const response = await axios.get(url, { headers: { 'responseType': 'blob' }})
          .catch((error: AxiosError) =>
          {
              return Promise.reject(this.handleError(error));
          });

        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'export.csv');
        document.body.appendChild(link);
        link.click();

        return response.data;
    }

    public static async post<T>(url: string, body?: any) : Promise<T>
    {
        url = urlBase + url;
        const response = await axios.post(url, body, { headers: this.createHeader()})
          .catch((error: AxiosError) =>
          {
              return Promise.reject(this.handleError(error));
          });

        return response.data;
    }

    public static async put<T>(url: string, body?: any) : Promise<T>
    {
        url = urlBase + url;
        const response = await axios.put(url, body, { headers: this.createHeader()})
          .catch((error: AxiosError) =>
          {
              return Promise.reject(this.handleError(error));
          });

        return response.data;
    }

    public static async delete<T>(url: string) : Promise<T>
    {
        url = urlBase + url;
        const response = await axios.delete(url, { headers: this.createHeader()})
          .catch((error: AxiosError) =>
          {
              return Promise.reject(this.handleError(error));
          });

        return response.data;
    }

    private static createHeader(): Record<string, string>
    {
        return {
            Authorization: `Bearer ${authRepository.user?.token}`,
            'Content-Type': 'application/json',
        };
    }

    private static handleError(error: AxiosError): ApiError
    {
        if (error.response === undefined)
        {
            return new ApiError(ApiErrorType.NetworkError, "Network error.");
        }

        let message = `[${error.response.status} ${error.response.statusText}] ${error.response.data}`

        if (error.response.status === 400)
        {
            return new ApiError(ApiErrorType.BadRequest, message);
        }
        else if (error.response.status === 401)
        {
            authRepository.logout();

            message = `[${error.response.status} ${error.response.statusText}] Login expired.`;
            return new ApiError(ApiErrorType.Unauthorised, message);
        }
        else if (error.response.status === 404)
        {
            return new ApiError(ApiErrorType.NotFound, message);
        }
        else if (error.response.status === 500)
        {
            return new ApiError(ApiErrorType.InternalServerError, message);
        }

        return new ApiError(ApiErrorType.NetworkError, "Network error.");
    }
}